import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Icon, Select, Spinner } from '@a-type/ui';
import { useGameSuite, withGame } from '@long-game/game-client';
import { useTransition } from 'react';
export const RoundHistoryControl = withGame(function RoundHistoryControl({}) {
    const suite = useGameSuite();
    const roundIndex = suite.viewingRoundIndex;
    const latestRoundIndex = suite.latestRoundIndex;
    const isCurrent = suite.isViewingCurrentRound;
    const [transitioning, startTransition] = useTransition();
    const loadRound = (index) => {
        startTransition(async () => {
            await suite.loadRoundUnsuspended(index);
            suite.showRound(index);
            // preload adjacent rounds if any
            if (index > 0) {
                suite.loadRoundUnsuspended(index - 1);
            }
            if (index < latestRoundIndex) {
                suite.loadRoundUnsuspended(index + 1);
            }
        });
    };
    return (_jsxs(Box, { layout: "center center", gap: "sm", children: [_jsx(Button, { size: "small", onClick: () => {
                    loadRound(roundIndex - 1);
                }, disabled: roundIndex === 0, children: _jsx(Icon, { name: "previous", size: 10 }) }), _jsxs(Select, { value: roundIndex.toString(), onValueChange: (v) => {
                    if (v === null)
                        return;
                    const asInt = parseInt(v, 10);
                    loadRound(asInt);
                }, children: [_jsxs(Select.Trigger, { size: "small", children: [_jsx(Select.Value, { children: (indexString) => suite.gameDefinition.getRoundLabel?.({
                                    roundIndex: parseInt(indexString, 10),
                                    members: suite.members,
                                }) ?? `Round ${parseInt(indexString, 10) + 1}` }), transitioning ? _jsx(Spinner, { size: 12 }) : _jsx(Select.Icon, {})] }), _jsx(Select.Content, { children: Array.from({ length: latestRoundIndex + 1 }).map((_, i) => (_jsx(Select.Item, { value: i.toString(), children: suite.gameDefinition.getRoundLabel?.({
                                roundIndex: i,
                                members: suite.members,
                            }) ?? `Round ${i + 1}` }, i))) })] }), _jsx(Button, { size: "small", onClick: () => {
                    if (isCurrent) {
                        return;
                    }
                    loadRound(roundIndex + 1);
                }, disabled: isCurrent, children: _jsx(Icon, { name: "next", size: 10 }) }), _jsx(Button, { size: "small", onClick: () => {
                    loadRound(latestRoundIndex);
                }, disabled: isCurrent, style: { display: isCurrent ? 'none' : undefined }, children: _jsx(Icon, { name: "skipEnd", size: 10 }) })] }));
});
//# sourceMappingURL=RoundHistoryControl.js.map